module.exports = __webpack_public_path__ + "public/img/build-banner.73f150c5.png";